/******/ (() => { // webpackBootstrap
class ScrollingBanner extends HTMLElement {
  constructor() {
    super();
    this.duplicatedLinks = this.querySelectorAll('ol[data-duplicated] a');
    this.updateScheduledText = this.updateScheduledText.bind(this);
  }

  connectedCallback() {
    this.init();
    this.updateScheduledText();
    document.addEventListener('visibilitychange', this.updateScheduledText);
  }

  disconnectedCallback() {
    window.clearTimeout(this.expiryTimer);
    document.removeEventListener('visibilitychange', this.updateScheduledText);
  }

  updateScheduledText() {
    window.clearTimeout(this.expiryTimer);
    let nextChange = Infinity;
    this.querySelectorAll('[data-banner-ends-at]').forEach(text => {
      const endsAt = Number(text.dataset.bannerEndsAt) * 1000;
      if (!Number.isFinite(endsAt) || endsAt <= 0) return;
      const remaining = endsAt - Date.now();
      if (remaining <= 0) {
        text.textContent = text.dataset.bannerTextAfter;
      } else {
        nextChange = Math.min(nextChange, remaining);
      }
    });
    // Also update cached pages and pages left open when the offer ends.
    if (Number.isFinite(nextChange)) {
      this.expiryTimer = window.setTimeout(this.updateScheduledText, Math.min(nextChange, 2147483647));
    }
  }

  init() {
    this.duplicatedLinks.forEach(link => {
      link.setAttribute('tabindex', '-1'); //prevents focusing on a duplicated link on keyboard nav
    });
  }

}

// Only define the custom element if it doesn't already exist
if (!customElements.get('scrolling-banner')) customElements.define('scrolling-banner', ScrollingBanner);

/******/ })()
;
